import { FormControl, FormLabel, IconButton, FormHelperText, Typography, Grid, Tooltip, Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import './../App.css';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useState, useEffect } from "react";
import TimeSlot from "./TimeSlot";
import axios from "axios";
import * as constants from "../constants";
export default function DayTimePicker({name, control, setValue, errors, question, helper, required}) {

    const [days, setDays] = useState([
        {name: "Mon", count:0, slots: []},
        {name: "Tue", count:0, slots: []},
        {name: "Wed", count:0, slots: []},
        {name: "Thu", count:0, slots: []},
    ])

    const [touched, setTouched] = useState(false)


    const increaseCount = (day) => {
        if (!touched) {setTouched(true)}
        const newDays = [...days]
        const ind = newDays.findIndex(obj => obj.name === day.name)
        newDays[ind].count += 1
        newDays[ind].slots.push({time: "", timezone: ""})
        setDays(newDays)
    }

    const decreaseCount = (day) => {
        if (!touched) {setTouched(true)}
        const newDays = [...days]
        const ind = newDays.findIndex(obj => obj.name === day.name)
        if(newDays[ind].count > 0) 
        {
            newDays[ind].count -= 1
            newDays[ind].slots.pop()
        }
        setDays(newDays)
    }

    const setTime = (time, day, slotind, val) => {
        if (!touched) {setTouched(true)}
        const newDays = [...days]
        const ind = newDays.findIndex(obj => obj.name === day)
        if(newDays[ind].count > 0) 
        {
            newDays[ind].slots[slotind][val] = time
        }
        setDays(newDays)
    }

    const setTimeAndZone = (time, day, slotind, timezone) => {
        if (!touched) {setTouched(true)}
        const newDays = [...days]
        const ind = newDays.findIndex(obj => obj.name === day)
        if(newDays[ind].count > 0)
        {
            newDays[ind].slots[slotind].time = time
            newDays[ind].slots[slotind].timezone = timezone
        }
        setDays(newDays)
    }
      
    useEffect(() => {
        setValue(name, days, {shouldValidate: touched});
    }, [name, days, touched, setValue]);
    useEffect(() => {
        axios.post(constants.serverURL + "getMentorSchedule", {},      {
            withCredentials: true,
        }).then(response => {
            let mon = JSON.parse(response.data[1][0].monday)
            let tue = JSON.parse(response.data[1][0].tuesday)
            let wed = JSON.parse(response.data[1][0].wednesday)
            let thu = JSON.parse(response.data[1][0].thursday)
            for (let i = 0; i < mon.length; i++) {
                increaseCount({name: 'Mon'})
                setTimeAndZone(mon[i].time, "Mon", i, mon[i].timezone)
            }
            for (let i = 0; i < tue.length; i++) {
                increaseCount({name: 'Tue'})
                setTimeAndZone(tue[i].time, "Tue", i, tue[i].timezone)
            }
            for (let i = 0; i < wed.length; i++) {
                increaseCount({name: 'Wed'})
                setTimeAndZone(wed[i].time, "Wed", i, wed[i].timezone)
            }
            for (let i = 0; i < thu.length; i++) {
                increaseCount({name: 'Thu'})
                setTimeAndZone(thu[i].time, "Thu", i, thu[i].timezone)
            }
        }).catch((error) => {
        })
    }, [])

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={[]}
            render={({ field }) => 
            <FormControl error={errors? true: false} fullWidth>
                <FormLabel required={required}>{question}</FormLabel>
                {helper? helper.map(text => (
                    <FormHelperText key={text} className="wrap-it helper">{text}</FormHelperText>
                )) : null}

                {days.map(day => (
                    <div className="col-center">
                        <Grid container px={0.8} key={day.name} {...field} >
                            <Grid item xs={2} mt={0.8}>
                                <div className="slot-day">{day.name}</div>
                            </Grid>
                            <Grid item xs={8} mt={0.8}>
                                {day.count ===0 ? <div className="unavailable center-align"> Unavailable </div> : null}
                            </Grid>
                            <Grid item xs={2}>
                                <div className="slot-button">
                                    <Tooltip title="Add a slot">
                                        <IconButton size="small" className="time-icon" onClick={() => increaseCount(day)}>
                                            <AddCircleOutlineIcon/>
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Remove last slot">
                                        <IconButton size="small" className="time-icon" onClick={() => decreaseCount(day)} disabled={day.count===0}>
                                            <RemoveCircleOutlineIcon/>
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </Grid>
                        </Grid> 
                        <div className="slots" fullWidth>
                            {day.count !==0 ?
                            [...Array(day.count)].map((i, key) => <TimeSlot key={key} time={day.slots[key].time} timezone={day.slots[key].timezone} setTime={setTime} day={day.name} slot={key} defaults={days}/>)
                            : null}
                        </div>
                    </div>
                ))
                }
                <Typography className="font-14 error-message">
                    {errors?.message}
                </Typography>
            </FormControl>
            }
        />
    );
};
